import {
  documentFileControllerAttachFile,
  documentFileControllerGetDownloadUrl,
} from "@/lib/gen-api";

export function useDocumentFileAction() {
  return {
    attachFile: async (documentUuid: string, fileUuid: string) => {
      await documentFileControllerAttachFile({
        path: { documentUuid, fileUuid },
        throwOnError: true,
      });
    },
    getDownloadUrl: async (documentUuid: string, fileUuid: string) => {
      const response = await documentFileControllerGetDownloadUrl({
        path: { documentUuid, fileUuid },
        throwOnError: true,
      });
      return response.data.url;
    },
  };
}
